export enum EAmlzFormularSteps {
    C1 = '1',
    C2 = '2',
    C3A = '3A',
    C3B = '3B',
    C4 = '4',
    C5 = '5',
    C6 = '6'
}
